import { type RouteRecordRaw } from "vue-router";
import { ROUTE_NAME } from "@/shared/constants/routes";

export const routes: RouteRecordRaw[] = [
  {
    path: "/payments/memberships",
    name: ROUTE_NAME.PAYMENT_MEMBERSHIPS,
    meta: { requiresPayments: true },
    component: () => import("./views/ViewSubscriptions.vue"),
  },
  {
    path: "/payments/registrations",
    name: ROUTE_NAME.PAYMENT_REGISTRATIONS,
    meta: { requiresPayments: true },
    component: () => import("./views/ViewRegistrations.vue"),
  },
  {
    path: "/payments/offerings/create/:offering_type?",
    name: ROUTE_NAME.PAYMENT_OFFERINGS_CREATE,
    meta: { requiresPayments: true },
    component: () => import("./views/CreateOffering.vue"),
  },
  {
    path: "/payments/offerings/:offeringId/signup",
    name: ROUTE_NAME.CREATE_OFFERING_SIGNUP,
    meta: { requiresPayments: true },
    component: () => import("./views/CreateOfferingSignupView.vue"),
  },
  {
    path: "/payments/offerings/:id/edit",
    name: ROUTE_NAME.PAYMENT_OFFERINGS_EDIT,
    meta: { requiresPayments: true },
    component: () => import("./views/EditOffering.vue"),
  },
  {
    path: "/payments/registrations/registrant/:id",
    name: ROUTE_NAME.PAYMENT_REGISTRANT_VIEW,
    meta: { requiresPayments: true },
    component: () => import("./views/ViewRegistrant.vue"),
  },
  {
    path: "/payments/memberships/:id",
    name: ROUTE_NAME.PAYMENT_MEMBERSHIPS_VIEW,
    meta: { requiresPayments: true },
    component: () => import("./views/ViewOffering.vue"),
  },
  {
    path: "/payments/memberships/membership/:id",
    name: ROUTE_NAME.PAYMENT_MEMBERSHIPS_MEMBER_VIEW,
    meta: { requiresPayments: true },
    component: () => import("./views/ViewSubscriberMembership.vue"),
  },
  {
    path: "/payments/registrations/:id",
    name: ROUTE_NAME.PAYMENT_REGISTRATIONS_VIEW,
    meta: { requiresPayments: true },
    component: () => import("./views/ViewOffering.vue"),
  },
];
